import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { keyframes as emotionKeyFrames } from '@emotion/react';
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
export function getFinalKeyFrames(keyFrames) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    initialKeyFrames = _ref.initialKeyFrames,
    displayInitialAnimation = _ref.displayInitialAnimation;
  var finalKeyFrames = keyFrames;
  if (!_isEmpty(initialKeyFrames) && displayInitialAnimation) {
    finalKeyFrames = initialKeyFrames;
  }
  if (_isEmpty(finalKeyFrames)) {
    return null;
  }
  if (_isString(finalKeyFrames)) {
    finalKeyFrames = emotionKeyFrames(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", "\n    "])), finalKeyFrames);
  }
  return finalKeyFrames;
}